





















































import { Component, Vue, Watch } from 'vue-property-decorator';
import * as firebase from 'firebase/app';
import { db } from '@/main';
import User from '@/interfaces/User';
import {
  required, email, confirmed, min,
} from 'vee-validate/dist/rules';
import {
  extend, ValidationObserver, ValidationProvider, setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('email', {
  ...email,
  message: '{_field_} must be a valid email',
});
extend('confirmed', {
  ...confirmed,
  message: '{_field_} does not match.',
});
extend('min', {
  ...min,
  message: '{_field_} may not be less than {length} characters.',
});

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Profile extends Vue {
  currentUser: User;

  password: string;

  confirmPassword: string;

  oldPassword: string;

  constructor() {
    super();
    this.currentUser = {} as User;
    this.password = '';
    this.confirmPassword = '';
    this.oldPassword = '';
  }

  saveProfile() {
    (this.$refs.profileObserver as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        const user = firebase.auth().currentUser;
        if (user) {
          user.updateProfile({ displayName: this.currentUser.name });
          user.updateEmail(this.currentUser.email);
          db.collection('users').doc(user.uid).update({
            phoneNumber: this.currentUser.phoneNumber,
            name: this.currentUser.name,
            email: this.currentUser.email,
          });
        }
      });
  }

  changePassword() {
    (this.$refs.profileObserver as Vue & { validate: () => Promise<boolean> })
      .validate().then((success) => {
        if (!success) return;

        const user = firebase.auth().currentUser;
        if (user) {
          const cred = firebase.auth.EmailAuthProvider.credential(this.currentUser.email, this.oldPassword);
          user.reauthenticateWithCredential(cred).then(() => {
            user.updatePassword(this.password);
          });
        }
      });
  }

  verifyEmail() {
    if (this.currentUser && this.currentUser.email) {
      const user = firebase.auth().currentUser;
      if (user) {
        user.sendEmailVerification();
      }
    }
  }

  created() {
    this.currentUser = this.currentUserStore;
  }

  get currentUserStore() {
    return this.$store.state.currentUser;
  }

  @Watch('currentUserStore')
  onCurrentUserChanged(value: User) {
    this.currentUser = value;
  }
}
